import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, Grid } from '@material-ui/core';
import { Amount, Page, AppBar, ScreenLoader, EmptyState } from 'components';
import { anketsStore, contractsStore } from 'stores';
import { ru } from 'locale';
import { NoData as NoDataBg } from 'resources/images';
import useStyles from './ContractsScreen.styles';

const ContractsScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { fetchState, contracts } = contractsStore;
  const hasContracts = contracts.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        contractsStore.getContracts(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderContracts = () => {
    if (!hasContracts) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfContracts }}
          title={ru.emptyList(ru.listOfContracts)}
        />
      );
    }

    return (
      <Box mt={2}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{ru.name}</TableCell>
              <TableCell>{ru.count}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {contracts.map((contract, idx) => {
              return (
                /* eslint-disable-next-line react/no-array-index-key */
                <TableRow key={idx}>
                  <TableCell>{contract.name}</TableCell>
                  <TableCell align="right">
                    {idx % 2 === 0 ? (
                      contract.value
                    ) : (
                      <Amount
                        color="textPrimary"
                        amount={{ value: contract.value, currency: { code: 'RUR', minority: 0 } }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar title={ru.governmentContracts} onNavButtonClick={handleBackClick} />
        {fetchState === 'pending' && <ScreenLoader />}

        <Grid
          container
          item
          direction="column"
          justify={hasContracts ? 'flex-start' : 'center'}
          className={cn({
            [classes.content]: !hasContracts,
          })}
        >
          {fetchState === 'fulfilled' && renderContracts()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default ContractsScreen;
